import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ConversationAgentEntity } from './conversation-agent.entity';

@Entity('_conversation_agent_daily_usage')
@Index(['date', 'conversationAgentId'], { unique: true })
export class ConversationAgentDailyUsageEntity extends BaseEntity {
	// Time Period
	@Column({ type: 'date' })
	public date!: Date;

	@Column({ type: 'int', unsigned: true })
	public year!: number;

	@Column({ type: 'int', unsigned: true })
	public month!: number;

	@Column({ type: 'int', unsigned: true })
	public dayOfMonth!: number;

	@Column({ type: 'int', unsigned: true })
	public dayOfWeek!: number; // 0=Sunday, 1=Monday, ..., 6=Saturday

	@Column({ type: 'enum', enum: ['weekday', 'saturday', 'sunday'] })
	public dayType!: 'weekday' | 'saturday' | 'sunday';

	// Usage Metrics
	@Column({ type: 'int', unsigned: true, default: 0 })
	public voiceSeconds!: number;

	@Column({ type: 'int', unsigned: true, default: 0 })
	public llmTokens!: number;

	@Column({ type: 'int', unsigned: true, default: 0 })
	public totalVoice!: number;

	@Column({ type: 'int', unsigned: true, default: 0 })
	public totalChats!: number;

	// Required: Per-Agent (NOT nullable)
	@Column({
		name: '_fk__conversation_agent__id',
		type: 'int',
		unsigned: true,
	})
	public conversationAgentId!: number;

	@ManyToOne(() => ConversationAgentEntity)
	@JoinColumn({ name: '_fk__conversation_agent__id' })
	public conversationAgent?: ConversationAgentEntity;
}
